import { Fragment } from 'react';

import { Divider } from '@/components/shared/Divider/Divider.tsx';
import { FAQCollapsible } from '@/components/shared/FAQCollapsible/FAQCollapsible.tsx';
import { PageHeading } from '@/components/shared/PageHeading/PageHeading.tsx';
import { faq } from '@/constants';

import cn from './styles.module.sass';

export const Help = () => {
    return (
        <div className={cn.container}>
            <PageHeading pageName="Помощь" backToPrevLocation />
            <div className={cn.faqContainer}>
                <div className={cn.faq}>
                    <h3 className={cn.faqHeading}>Частые вопросы</h3>
                    <div className={cn.faqList}>
                        {Object.entries(faq).map(([key, value], i, arr) => (
                            <Fragment key={key}>
                                <FAQCollapsible title={key} content={value} />
                                {i < arr.length - 1 && <Divider />}
                            </Fragment>
                        ))}
                    </div>
                </div>
                <div className={cn.contacts}>
                    <h3 className={cn.contactsHeading}>Другой вопрос?</h3>
                    <div className={cn.contactsList}>
                        <div className={cn.contactInfo}>
                            <h4>Служба поддержки абонентов:</h4>
                            <p>
                                <a href="tel:+74952478888">+7-495-247-88-88</a>
                            </p>
                        </div>
                        <div className={cn.contactInfo}>
                            <h4>По ошибкам в приложении:</h4>
                            <p>
                                <a href="mailto:feedback@k7.ru">feedback@k7.ru</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
